import React from 'react';
import { connect } from 'react-redux';
import makeForm from '../makeForm';
import ContinueButton from '../ContinueButton';
import { dniCleaveOptions, url } from '../../../../config';
import { choices } from '../../../../choices';
import { tooltips } from '../../../../tooltips';
import Tooltip from 'rc-tooltip';
import IncomeCards from '../IncomeUtils';
import NewIncomeForm from './NewIncomeForm';
import FormGroup from '../../Common/FormGroup';
import Input from '../../Common/Input';
import RadioGroup from '../../Common/RadioGroup';
import GoBackButton from '../../Common/GoBackButton';
import Help from '../../../../assets/images/icons/help-circle.svg';
import s from '../../Common/GoBackButton.scss';
import sc from '../ChatsForm.scss';

class CoborrowerForm extends React.Component {
    state = {
        thereismore: false,
        incomesLength: this.props.values.incomes.length,
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let thereismore = prevState.thereismore
        if (nextProps.values.incomes.length > prevState.incomesLength) thereismore = false;
        return {
            thereismore,
            incomesLength: nextProps.values.incomes.length,
        };
    }

    changeTherismore = bool => () => {
        this.setState({ thereismore: bool });
    }

    render() {
        const {
            postCoborrowerForm,
            errors,
            deleteIncome,
            coborrowerSubmit,
            newIncome,
            match,
            editIncome,
            values,
            handleChange,
            handleCleaveChange,
            is_staff,
            changeWithCoborrower,
            with_coborrower,
            apptype
        } = this.props;
        const { thereismore, withCoborrower } = this.state;
        const { incomes } = this.props.values;
        return (
            <div>
                <div className={sc.formContainer}>
                    <div className={s.goBack}><GoBackButton children={'Volver'} link={url('ingresos', apptype)}/></div>
                    <h3 className="chat-title">Datos del co-titular
                        <Tooltip destroyTooltipOnHide placement="bottom" trigger={['click', 'hover']} overlayStyle={{ maxWidth: '300px' }} overlay={tooltips.coborrower.map(({ description }) => [description])}>
                            <img className={sc.helpImg} src={Help} alt={"icono de ayuda"}></img>
                        </Tooltip>
                    </h3>
                    <RadioGroup label="¿Vas a aplicar con alguien más?" onChange={changeWithCoborrower} name="withCoborrower" selected={with_coborrower} flexButton={true}>
                        {[
                            ['Si', true],
                            ['No', false],
                        ]}
                    </RadioGroup>
                    {with_coborrower === true ?
                        <div>
                            <FormGroup>
                                <Input label="Nombre" name="first_name" value={values.first_name} errors={errors.first_name} onChange={handleChange} />
                            </FormGroup>
                            <FormGroup>
                                <Input label="Apellido" name="last_name" value={values.last_name} errors={errors.last_name} onChange={handleChange} />
                            </FormGroup>
                            <FormGroup>
                                <Input label="DNI" name="dni" value={values.dni} onChange={handleCleaveChange} errors={errors.dni} cleaveOptions={dniCleaveOptions} type="tel" />
                            </FormGroup>
                            <RadioGroup label="¿Cuál es tu relación con el co-titular?" errors={errors.relation} onChange={handleChange} name="relation" selected={values.relation}>
                            {choices.relations.map(({ text, value }) => [text, value])}
                            </RadioGroup>
                            {is_staff &&
                                <div>
                                    <RadioGroup
                                        errors={errors.civil_status}
                                        label="Estado Civil"
                                        name="civil_status"
                                        selected={values.civil_status}
                                        onChange={handleChange}
                                    >
                                        {choices.civil_status.map(({ text, value }) => [text, value])}
                                    </RadioGroup>
                                    <FormGroup label="Ocupación" errors={errors.occupation}>
                                        <Input
                                            name="occupation"
                                            value={values.occupation || ''}
                                            onChange={handleChange}
                                        />
                                    </FormGroup>
                                </div>
                            }
                            <IncomeCards incomes={incomes} deleteIncome={deleteIncome} is_staff= {is_staff} url={match.url} path={match.path} editIncome={editIncome} />
                            {(!!incomes.length && !thereismore) && <p style={{ textAlign: 'center', marginBottom: '35px' }}><a className={sc.addIncome} onClick={this.changeTherismore(true)}>Agregar otros ingresos</a></p>}
                            {(thereismore || !incomes.length) &&
                                <NewIncomeForm
                                    onSubmit={(newIncome) => coborrowerSubmit(values, newIncome)}
                                    errors={errors.newIncome}
                                    values={newIncome}
                                    coborrower
                                    incomesLength={incomes.length}
                                    cancelForm={this.changeTherismore(false)}
                                    showCancel={!!incomes.length}
                                    placeholder={'35.000'}
                                />
                            }
                            {thereismore === false && !!incomes.length && <ContinueButton autoFocus={false} type="button" onClick={() => postCoborrowerForm(values)} />}
                        </div>
                        :
                        <ContinueButton autoFocus={false} sticky={true} type="button" onClick={() => postCoborrowerForm(values)}/>
                    }
                </div>
            </div>
        );
    }
}


const mapStateToProps = ({ user }) => ({ is_staff: !!user.is_staff });


export default connect(mapStateToProps)(makeForm(CoborrowerForm));
